import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify';
import Input from '../../components/Input';
import Button from '../../components/Button';
import Toast from '../../components/Toast';
import { options } from '../../helpers/toastOptions';
import api from '../../services/api';
import {
  Background,
  Container,
  Content,
  SignIn,
  Form,
  ErrorContainer
} from './styled';

const ForgotPassword = () => {
  const history = useHistory();
  const signInValidationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(/^([\w.-]+)@([\w-]+)((\.(\w){2,25})+)$/, 'E-mail inválido')
      .required('E-mail é obrigatório')
  });

  const { handleSubmit, register, errors, setError } = useForm({
    resolver: yupResolver(signInValidationSchema)
  });

  const onSubmit = async (data) => {
    try {
      await api.post('http://143.244.202.73:5000/User/ForgotPassword', data);
      history.push('/');
      toast(
        <Toast
          title="Senha enviada com sucesso!"
          content="Verifique sua caixa de entrada."
          type="success"
        />,
        options
      );
    } catch (error) {
      setError('email', {
        message:
          'Não foi possível enviar o email de recuperação de senha, Verifique se o email está correto.'
      });
      toast(
        <Toast
          title="Não foi possível enviar o email de recuperação de senha."
          content="Verifique se o email está correto."
          type="error"
        />,
        options
      );
    }
  };
  return (
    <Container>
      <Content>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <span>Recuperar senha</span>
          <p>Para recuperar sua senha, digite o e-mail no campo abaixo:</p>
          <Input
            type="email"
            name="email"
            placeholder="E-mail"
            ref={register}
            error={!!errors.email?.message}
          />
          <ErrorContainer>{errors.email?.message}</ErrorContainer>

          <Button text="Recuperar senha" />
          <SignIn>
            <p>Lembrou a senha?</p>
            <Link to="/">Faça o login</Link>
          </SignIn>
        </Form>
      </Content>
      <Background>
        <p>© 2020 ESMenezes - Todos os direitos estão reservados.</p>
      </Background>
    </Container>
  );
};

export default ForgotPassword;
